<template>
  <div class="detail_content">
  <!-- <div class="detail_content"> -->
    <div class="detail_label">
      {{titleLabel}}
      <div v-if='!notRequiredFlag' class='require_items_label'>
        {{requiredItemLabel}}
      </div>
    </div>
    <select class='detail_input_field auto_logout_second_list' @change='inputUpdate(sleepFunctionTimeList)'>
      <option disabled selected value="">{{initialValueLabel}}</option>
      <option v-for="n in sleepFunctionTimeList" :key="n" :value="n">
        {{n/3600}}時間
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    notRequiredFlag: Boolean,
    initialValue: Number
  },
  data () {
    return {
      sleepFunctionTimeList: [
        3600, // 1時間
        10800, // 3時間
        21600, // 6時間
        28800, // 8時間
        43200, // 12時間
        64800, // 18時間
        86400 // 24時間
      ]
    }
  },
  computed: {
    requiredItemLabel () {
      return this.$store.state.error.requiredItemLabel
    },
    initialValueLabel () {
      return parseInt(this.initialValue / 3600) + '時間'
    }
  },
  methods: {
    inputUpdate (e) {
      this.$emit('inputUpdate', event.target.value)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/dropDownSection.vue